"use client";
import {
  useCompositeGroup
} from "../__chunks/IEKMDIUY.js";
import "../__chunks/ZPO4YZYE.js";
import "../__chunks/7HVFURXT.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/HKOOKEDE.js";
import "../__chunks/Z32BISHQ.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/menu/menu-group.tsx
var TagName = "div";
var useMenuGroup = createHook(
  function useMenuGroup2(props) {
    props = useCompositeGroup(props);
    return props;
  }
);
var MenuGroup = forwardRef(function MenuGroup2(props) {
  const htmlProps = useMenuGroup(props);
  return createElement(TagName, htmlProps);
});
export {
  MenuGroup,
  useMenuGroup
};
